/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable @typescript-eslint/ban-types */
import { useConfig, useOidcWithAdmin } from '@revenuewell/front-end-bundle';
import { PropsWithChildren, createContext, useCallback, useEffect, useMemo, useState } from 'react';
import { NotificationApi } from '../../services/notification-service/notification-service';

export interface ISettingsContext {
  snooze: (expirationDate?: number) => Promise<void>;
  forms2Submission: boolean;
  snoozeExpirationDate?: number;
}

export const SettingsContext = createContext<ISettingsContext>(null!);

export function SettingsProvider({ children }: PropsWithChildren<{}>) {
  const [snoozeExpirationDate, setSnoozeExpirationDate] = useState<number | undefined>();
  const [forms2Submission, setForms2Submission] = useState<boolean>(false);

  const { config } = useConfig();
  const { oidcService } = useOidcWithAdmin();

  const notificationService = useMemo(() => {
    if (!(config && oidcService)) return;
    return new NotificationApi(config, oidcService);
  }, [config, oidcService]);

  useEffect(() => {
    if (notificationService) {
      notificationService.getNotificationStatus().then((status) => {
        setForms2Submission(status?.forms2Submission || false);
        if (status?.snoozeExpirationDate) {
          setSnoozeExpirationDate(+new Date(status.snoozeExpirationDate));
        }
      });
    }
  }, [notificationService]);

  const snooze = useCallback(
    async (expirationDate?: number): Promise<void> => {
      if (notificationService) {
        notificationService.setSnooze(expirationDate ? new Date(expirationDate) : new Date());
        setSnoozeExpirationDate(expirationDate);
      }
    },
    [notificationService, setSnoozeExpirationDate]
  );

  const providerValue = useMemo(
    () => ({
      forms2Submission,
      snoozeExpirationDate: (snoozeExpirationDate || 0) > +new Date() ? snoozeExpirationDate : undefined,
      snooze
    }),
    [forms2Submission, snoozeExpirationDate, snooze]
  );

  return <SettingsContext.Provider value={providerValue}>{children}</SettingsContext.Provider>;
}
